import { getDefaultMargin } from '../utils'

export const RadioDesignSettings = {
  'radio-design-width': {
    phone: [100],
    'phone-landscape': [100],
    tablet: [100],
    'tablet-landscape': [100],
    desktop: [100],
    tv: [100],
  },
  'radio-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
}
